import React from 'react'
import { Button, Checkbox, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

const CheckboxGroup = Checkbox.Group

const getListFilter = (values, selectedValues, onChange, onSearch, onClear) => {
  return ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    return (
      <div
        style={{
          padding: 8,
        }}
      >
        <div>
          <CheckboxGroup
            style={{
              overflowY: 'auto',
              maxHeight: 200,
              whiteSpace: 'normal',
            }}
            options={values}
            value={selectedValues}
            onChange={onChange}
          />
        </div>
        <Space>
          <Button
            type="primary"
            onClick={() => {
              onSearch()
              confirm()
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Поиск
          </Button>
          <Button
            onClick={() => {
              onClear()
              confirm()
            }}
            size="small"
            style={{
              width: 90,
            }}
          >
            Сбросить
          </Button>
        </Space>
      </div>
    )
  }
}

export default getListFilter
